// extracted by mini-css-extract-plugin
export default {"cls1":"Cta-cls1__de794d277a84e18eeb66","cls2":"Cta-cls2___0f2a9ae7fe53ee5811a Cta-cls1__de794d277a84e18eeb66"};